<p class="text-white">{{msg}}</p>
<div class="text-right">
    <a class="mx-1 cusror text-white" (click)="redirect()">Ok</a>
    <a class="mx-1 cusror text-white" (click)="dismissNotification()">Not now</a>
</div>